import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCollection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23 40H8V25h15zM40 40H25V25h15zM23 23H8V8h15zM40 23H25V8h15z" })
});
export default SvgCollection;
